//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibPositiveNegativeInputs',
  props: {
    value: {
      type: Object
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  methods: {
    handleChange: function handleChange(value, key) {
      var updatedValue = this.value || {};
      updatedValue[key] = value;

      if (!updatedValue.positive) {
        updatedValue.positive = '';
      }

      if (!updatedValue.negative) {
        updatedValue.negative = '';
      }

      this.$emit('input', updatedValue);
    }
  }
};